__turbopack_context__.v({
  "arrow": "index-module__hu9Mga__arrow",
  "name": "index-module__hu9Mga__name",
  "nickname": "index-module__hu9Mga__nickname",
  "overlay": "index-module__hu9Mga__overlay",
  "user": "index-module__hu9Mga__user",
});
